// src/features/auth/authThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { accountsApi  } from "../../services/accountsApi";

export const loadUserProfile = createAsyncThunk(
  'auth/loadUserProfile',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      console.log("authFlow, trying to get user profile from server...");
      const response = await dispatch(accountsApi.endpoints.getUserProfile.initiate()).unwrap();
      console.log("authFlow, got user profile: ", response);
      return response;
    } catch (error) {
      console.log("authFlow, error getting user profile: ", error);
      return rejectWithValue(error);
    }
  }
);
